import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output, TemplateRef, ViewChild} from '@angular/core'
import {BsModalRef, BsModalService, ModalModule} from "ngx-bootstrap/modal";
import {TranslatePipe} from '@ngx-translate/core';
import {NgIf} from '@angular/common';

@Component({
  selector: 'app-delete-card',
  templateUrl: './delete-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ModalModule,
    TranslatePipe,
    NgIf
  ],
  providers: [BsModalService],
  standalone: true
})
export class DeleteCardComponent {
  @Input() public itemName = '';
  @Input() public disabled = false;
  @Input() public showAsCard = true;

  @Output() public deleteTriggered: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild('confirmModal') public confirmModal!: TemplateRef<never>;

  public confirmModalRef?: BsModalRef;

  public triggerDelete() {
    this.confirmModalRef = this.bsModalService.show(this.confirmModal);
  }

  public confirmDelete() {
    this.confirmModalRef?.hide();
    this.deleteTriggered.emit();
  }

  constructor(private readonly bsModalService: BsModalService) {}
}
